/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hours__disclaimers[_ngcontent-%COMP%]{font-size:13px;color:#666}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){div.section[_ngcontent-%COMP%]{width:120%!important}}"];
export { styles as styles };
